import angular from 'angular';
import loansSignUpFormComponent from './loansSignUpForm.component';
import loansSignupFormFields from './loansSignUpFormFields/loansSignUpFormFields';
import loansSignUpFormLegalConditions from './loansSignUpFormLegalConditions/loansSignUpFormLegalConditions';

let loansSignUpFormModule = angular.module('loansSignUpForm', [
  loansSignupFormFields,
  loansSignUpFormLegalConditions
])

  .component('loansSignUpForm', loansSignUpFormComponent)

  .name;

export default loansSignUpFormModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpForm/loansSignUpForm.js